import { useNavigate } from 'react-router-dom';
import { IconUser, IconBrandWhatsapp } from '@tabler/icons-react';
import { format } from 'date-fns';

import { AgeDefault } from 'lib/DefaultData';
import { findColorType } from 'lib/uiHelpers';

import CardOurClassImage from './CardOurClassImage';

const CardOurClass = ({ item }) => {
  const navigation = useNavigate();

  const goToClassDetail = (paramsId, paramsDate) => {
    const formatDate = paramsDate
      ? format(paramsDate, 'yyyy-MM-dd')
      : format(new Date(), 'yyyy-MM-dd');
    navigation(`/learn/class-schedule?class_id=${paramsId}&date=${formatDate}`);
  };

  const goToViewClass = (paramsId) => {
    navigation(`/learn/class/view/${paramsId}`);
  };

  const goContactAdmin = () => {
    const phoneNumber = '6281290904616';
    const message = encodeURIComponent(
      `Hi Admin, saya tertarik dengan class "${item?.name || 'this class'}" (${
        item?.type || ''
      }) dan ingin mendapatkan informasi lebih lanjut.`,
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, '_blank');
  };

  const findAge = (paramsAge) => {
    const age = AgeDefault.find((item) => item.value === paramsAge);
    const res = age ? `${age.name} ${age.description}` : '-';
    return res;
  };

  if (!item) {
    return <div className="flex flex-row gap-2 py-4 justify-between items-center">NO IMAGE</div>;
  }

  return (
    <div>
      <div className="p-2 bg-white rounded-2xl relative overflow-hidden">
        <div className="group relative">
          <div className="relative">
            {item?.next_class_date && (
              <div className="absolute flex flex-col bottom-2 right-2 rounded-2xl py-2 px-3 max-w bg-white shadow-lg">
                <span className="text-xs font-normal text-kin-text leading-normal">Next Class</span>
                <p className="text-sm font-bold text-primary-main">
                  {item?.next_class_date ? format(item?.next_class_date, 'dd MMM yyyy') : '-'}
                </p>
              </div>
            )}
            <CardOurClassImage item={item} />
          </div>
          <div className="px-2 sm:px-3 py-3 text-kin-text flex flex-col gap-2">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 sm:gap-0">
              <div>
                <span className="mt-4 text-sm font-normal uppercase">{item?.subject || '-'}</span>
                <h3 className="text-lg font-bold leading-none max-h-[55px]">{item?.name || '-'}</h3>
                <span className="text-base font-semibold">{item?.theme || '-'}</span>
              </div>
              <div
                className={`px-3 py-0.5 rounded-2xl mt-2 sm:mt-0 w-max ${findColorType(
                  item?.type?.toLowerCase(),
                )}`}>
                <span className="text-sm font-semibold text-white capitalize">
                  {item?.type ? item.type : '-'}
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
              <div className="flex flex-row items-center gap-1">
                <div className="w-3.5 h-3.5 relative">
                  <img
                    alt="icon-star"
                    src="/kin/assest/image/icon-star.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-xs">{item?.age_group ? findAge(item?.age_group) : '-'}</span>
              </div>
              <div className="flex flex-row items-center gap-1">
                <IconUser className="w-4 h-4" />
                {item?.teachers?.length ? (
                  <span className="text-xs truncate max-w-[120px] sm:max-w-[200px]">
                    {item.teachers.map((t) => t.name).join(', ')}
                  </span>
                ) : (
                  <span className="text-xs text-gray-400">No Teacher This Time</span>
                )}
              </div>
              <div className="flex flex-row items-center gap-1">
                <div className="w-3 h-3 relative">
                  <img
                    alt="icon-clock"
                    src="/kin/assest/image/icon-clock.svg"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                </div>
                <span className="text-xs">
                  {item?.duration ? `${item.duration} mins` : '- mins'}
                </span>
              </div>
            </div>
            <div className="mt-2 h-[115px] overflow-hidden line-clamp-[8]">
              <div
                className="text-sm font-medium"
                dangerouslySetInnerHTML={{ __html: item?.description ? item?.description : '-' }}
              />
            </div>

            <div className="flex flex-row gap-2 mt-4">
              <button
                onClick={() => goToViewClass(item.id)}
                className="bg-white border border-kin-text text-kin-text rounded-[100px] justify-center items-center py-2 px-3 w-full sm:w-auto hover:bg-kin-text hover:text-white transition-colors">
                <span className="text-xs font-semibold block">VIEW CLASS</span>
              </button>
              {item?.type.toLowerCase() === 'special' || item?.type.toLowerCase() === 'regular' ? (
                <button
                  onClick={() => goToClassDetail(item.id, item?.next_class_date)}
                  className="bg-primary-main text-white rounded-[100px] py-2 px-3 w-full sm:w-auto flex justify-center items-center hover:bg-primary-dark transition-colors">
                  <span className="text-xs font-semibold block">BOOK CLASS</span>
                </button>
              ) : (
                <button
                  onClick={() => goContactAdmin()}
                  className="bg-[#25D366] text-white rounded-[100px] py-2 px-3 w-full sm:w-auto flex justify-center items-center gap-1.5 hover:bg-[#20BA5A] transition-colors">
                  <IconBrandWhatsapp className="w-4 h-4" />
                  <span className="text-xs font-semibold block">BOOK BY WHATSAPP</span>
                </button>
              )}
              {/* <button
                onClick={() => goContactAdmin()}
                className="bg-[#25D366] text-white rounded-[100px] py-2 px-3 w-full sm:w-auto flex justify-center items-center gap-1.5 hover:bg-[#20BA5A] transition-colors">
                <IconBrandWhatsapp className="w-4 h-4" />
                <span className="text-xs font-semibold block">BOOK BY WHATSAPP</span>
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardOurClass;
